<template>
  <div v-if="value">
    <div class="marvel-device iphone-x">
      <div class="notch">
        <div class="camera"></div>
        <div class="speaker"></div>
      </div>
      <div class="top-bar"></div>
      <div class="sleep"></div>
      <div class="bottom-bar"></div>
      <div class="volume"></div>
      <div class="overflow">
        <div class="shadow shadow--tr"></div>
        <div class="shadow shadow--tl"></div>
        <div class="shadow shadow--br"></div>
        <div class="shadow shadow--bl"></div>
      </div>
      <div class="inner-shadow"></div>
      <div class="screen" style="overflow: auto; z-index: 1;">
        <div style="position: sticky; top: 0px; width: 100%; z-index: 3;">
          <v-toolbar class="pt-4">
            <v-toolbar-title>
              <v-avatar size="36px" class="mr-2">
                <img
                  :src="
                    'https://graph.facebook.com/' +
                      selectedBot.pageid +
                      '/picture?width=100&height=100&SameSite=None'
                  "
                  alt
                />
              </v-avatar>
              <span style="font-weight: 400;">{{ shopName }}</span>
            </v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
        </div>
        <template v-for="(item, i) in value.template">
          <!-- <div class="pb-3" :key="`message_${i}`" v-if="item.type === 'message'">
        <message v-model="item.value" :index="i"></message>
      </div> -->
          <div
            class="mt-8"
            :key="`slideshow_${i}`"
            v-if="item.type === 'slideshow'"
            :style="`background: ${item.color.hex}`"
          >
            <template>
              <v-carousel
                height="auto"
                :key="`slideshow_${i}`"
                hide-delimiters
                style="box-shadow: none;"
              >
                <v-carousel-item
                  v-for="(image, i) in item.images"
                  :key="`carousel_${i}`"
                  :src="image ? image : ''"
                ></v-carousel-item>
              </v-carousel>
            </template>
          </div>
          <div
            class="pb-3 pa-3"
            :key="`message_readonly_${i}`"
            :style="`background: ${item.color.hex}`"
            v-if="item.type === 'message' && showPreview"
          >
            <message v-model="item.value" :index="`readonly-${i}`" :readonly="true"></message>
          </div>
          <div
            class="pb-3 pt-5"
            :style="`background: ${item.color.hex}`"
            :key="`productlist_${i}`"
            v-if="item.type === 'productlist'"
          >
            <product-list
              :images="item.images"
              :option="item.option"
              :categories="categories"
              :borderColor="item.borderColor.hex"
            >
            </product-list>
          </div>
          <div
            class="pb-3"
            :style="`background: ${item.color.hex}`"
            :key="`productslect_${i}`"
            v-if="item.type === 'productslect'"
          >
            <h2 class="ma-0 pa-3" :style="`color:${selectedBot.shopcolor}`">
              {{ item.titleName }}
            </h2>
            <product-list v-model="item.productSelect"> </product-list>
          </div>
          <div
            :style="
              `background: ${item.color.hex}; ${
                item.image[0] ? (item.padding ? 'padding: 10px' : '') : 'padding: 160px'
              };`
            "
            :key="`photo_${i}`"
            v-if="item.type === 'photo'"
          >
            <template v-if="item.image[0]">
              <v-img
                @click="openNewtab(item.url)"
                :style="item.url ? 'cursor: pointer' : ''"
                :src="item.image[0]"
                :aspect-ratio="item.option == '2to1' ? 16 / 9 : 1"
                color="grey"
              ></v-img>
            </template>
          </div>
          <div
            class="pb-3 pa-3"
            :style="`background: ${item.color.hex}`"
            :key="`youtube_${i}`"
            v-if="item.type === 'youtube'"
          >
            <iframe
              :id="`ytplayer_${i}`"
              type="text/html"
              allow="autoplay"
              :src="
                `https://www.youtube.com/embed/${item.url}?autoplay=${
                  item.autoplay ? '1' : '0'
                }&playlist=${item.url}&loop=${item.loop ? '1' : '0'}&mute=1`
              "
              frameborder="0"
            ></iframe>
          </div>
          <div
            class="pb-3 pa-3"
            :style="`background: ${item.color.hex}`"
            :key="`socialLink_${i}`"
            v-if="item.type === 'socialLink'"
          >
            <h2 :style="`color:${selectedBot.shopcolor}`">{{ item.titleName }}</h2>
            <template v-for="(data, index) in item.list">
              <div
                @click="openNewtab(data.url)"
                v-if="data.status"
                :key="index"
                class="intent-item z-border-red pa-2 text-xs-left"
                style="max-height: 52px; cursor:pointer"
                :style="`border-color:${data.borderColor ? data.borderColor.hex : '#000'}`"
              >
                <v-layout row wrap>
                  <v-flex xs3 class="text-xs-center">
                    <img :src="data.image" alt="" height="40" />
                  </v-flex>
                  <v-flex xs9 style="align-self: center;">
                    <span :style="`color:${data.fontColor ? data.fontColor.hex : '#000'}`">{{
                      data.title
                    }}</span>
                  </v-flex>
                </v-layout>
              </div>
            </template>
          </div>
        </template>

        <template>
          <v-bottom-nav
            :value="true"
            :color="selectedBot.shopcolor"
            dark
            style="height: 40px; padding-bottom: 25px; z-index: 1;"
            :style="value.checkoutBtn === 'fixed' ? 'position: sticky' : 'inherit'"
          >
            <v-btn flat value="nearby" style="margin-top: 5px;">
              <span>{{ $t('Checkout') }} </span>
              <v-badge color="red">
                <i style="font-size: 20px; margin-bottom: 3px;" class="fas fa-cart-plus"></i>
              </v-badge>
            </v-btn>
          </v-bottom-nav>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import ProductList from './templateType/ProductList'
import Message from './templateType/Message'
import Products from '@/components/view/template/ecommerce/Products'
import { methods } from '@chenfengyuan/vue-countdown'
export default {
  props: ['value', 'showPreview', 'categories', 'shopName'],
  components: {
    ProductList,
    Message,
    Products
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    })
  },
  methods: {
    openNewtab(url) {
      window.open(url, '_blank')
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/salePage/PreviewSalePage.vue